import type { SalaryPreference } from '.';
import type { JobSeekerProfileStructuredDataSalaryType } from '../../../../../../../../../../__generated__/types.gqlgenerated';
import type { GettextInterface } from '../../../../../../../../../../shared/I18n';

import { getLocaleCurrency } from '../../../../../../../../../../shared/util/salary/getLocaleCurrency';
import { getPayTypesToLabels } from '../../../../../../../../../../shared/util/salary/getPayTypesToLabels';
import { parseLocaleCurrencyAmount } from '../../../../../../../../../../shared/util/salary/parseLocaleCurrencyAmount';

export const payBounds = {
    ['HOURLY']: [2, 500],
    ['DAILY']: [30, 4000],
    ['WEEKLY']: [40, 20000],
    ['MONTHLY']: [100, 90000],
    ['YEARLY']: [2000, 1000000],
};

const localeStringOptions = {
    style: 'decimal',
} as const;

export const validatePayRange = (
    payValue: SalaryPreference,
    locale: string,
    gt: GettextInterface,
) => {
    const amount = parseLocaleCurrencyAmount(payValue.amount || '', locale);
    const type = payValue.salaryType as Exclude<
        JobSeekerProfileStructuredDataSalaryType,
        'BIWEEKLY'
    >;
    const payTypes = getPayTypesToLabels(gt);

    const [lowerBound, upperBound] = (type && payBounds[type]) || [0, Number.MAX_SAFE_INTEGER];
    if (amount && type) {
        const { currencySymbol } = getLocaleCurrency(locale);
        if (amount <= lowerBound) {
            return gt.gettext('Add a pay higher than {0}{1} {2}, or adjust the pay period.', [
                currencySymbol,
                lowerBound.toLocaleString(locale, localeStringOptions),
                payTypes[type],
            ]);
        } else if (amount >= upperBound) {
            return gt.gettext('Add a pay lower than {0}{1} {2}, or adjust the pay period.', [
                currencySymbol,
                upperBound.toLocaleString(locale, localeStringOptions),
                payTypes[type],
            ]);
        }
    }

    return undefined;
};
